export default "__VITE_ASSET__CT8G$0dH__"